
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gtbMwkW77T18zyU779oaQUPYjcWpynuxVhyWlC63Dg9gMeta } from "/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexR_eMBvI5uVcKJvJOlYy9FDLqXDWQRSZ_45hMy5fYcc1moMeta } from "/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchtsxvvWsiv93VyoC4Hhjg_45XCh2Zfx3HFhcuoVcCAh5VoMeta } from "/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexDn2HsWGbWHx0AaAisk_Db_da8YdADrPVuz_45ZI1b_sNEMeta } from "/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93AoS8dFpI0TozCeBaUnvvOBUG3SWZHFSoQIFyCMxVZfQMeta } from "/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexTzKskukOLvORff8BX5_d52av8D0g_45BAqEXvUhaPW1ekMeta } from "/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93gj8aDyy_45j34du0QebUBUHLxg5CqhkE1_xEnkswnZB5cMeta } from "/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexKAlvKXdjTKazKIDJqTLjPa1XdfAJJcIaR0ggdpkooDYMeta } from "/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93UdS5aM08DB8rV4s4hcDavhMQ5XzyPYfhrpmHAP0sJS8Meta } from "/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index7CgozW2h9qimj_ksd04OY_d0lpOjhuIyYbjmK3idU3kMeta } from "/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexbJLk5hv5GnlHJzKgd1o_LTnrcbXAk2pRR4kz0XN7eBEMeta } from "/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexTzKskukOLvORff8BX5_d52av8D0g_45BAqEXvUhaPW1ekMeta || {},
    component: () => import("/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexKAlvKXdjTKazKIDJqTLjPa1XdfAJJcIaR0ggdpkooDYMeta || {},
    component: () => import("/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index7CgozW2h9qimj_ksd04OY_d0lpOjhuIyYbjmK3idU3kMeta || {},
    component: () => import("/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexbJLk5hv5GnlHJzKgd1o_LTnrcbXAk2pRR4kz0XN7eBEMeta || {},
    component: () => import("/codebuild/output/src4285989557/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]